<template>
  <rpm-input
    type="select"
    class="w-full"
    optionValue="label"
    optionLabel="label"
    :options="question.options"
    :label="!noLabel ? question.label:''"
    :required="!noLabel ? question.required:''"
    :optional="!noLabel ? !question.required:''"
  ></rpm-input>
</template>

<script>
export default {
  name: "SelectAnswer",
  props: {
    question: {
      type: Object,
      required: true
    },
    noLabel: {
      type: Boolean,
      default: false
    },
  },
};
</script>
